module.exports = __webpack_public_path__ + "static/media/om_eyeshape_downturned_blue.0392be49.png";